import { KeyboardEvent, useRef, useState } from "react";
import {
  Button as UIButton,
  Popper,
  MenuList,
  ClickAwayListener,
  MenuItem,
  Paper,
  Grow,
} from "@mui/material";
import More2FillIcon from "remixicon-react/More2FillIcon";
import { createUseStyles } from "$utils/createUseStyles";
import JTooltip from "$components/JTooltip/JTooltip";
import { EDB_IS_DISABLED_MSG } from "$containers/EDB/constants";

type Props = {
  disabled: boolean;
  isProductDeletable: boolean;
  onDeleteFromOP: () => void;
  onDeleteFromEdb: () => void;
};

function PopperButtons({
  disabled,
  onDeleteFromOP,
  onDeleteFromEdb,
  isProductDeletable,
}: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const anchor = useRef<any>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const deleteOp = () => {
    handleClose();
    onDeleteFromOP();
  };

  const deleteEdb = () => {
    handleClose();
    onDeleteFromEdb();
  };

  const handleListKeyDown = (event: KeyboardEvent<HTMLUListElement>) => {
    if (event.key === "Tab") {
      event.preventDefault();
      handleClose();
    }
  };

  return (
    <div ref={anchor}>
      <JTooltip title={disabled && EDB_IS_DISABLED_MSG}>
        <UIButton
          onClick={handleToggle}
          style={{ minWidth: 25 }}
          disabled={disabled}
        >
          <More2FillIcon />
        </UIButton>
      </JTooltip>
      <Popper
        open={open}
        anchorEl={anchor.current}
        placement="bottom-end"
        transition
        style={{ zIndex: 2 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                  style={{ padding: 0 }}
                >
                  <MenuItem className={classes.popperBtn} onClick={deleteOp}>
                    Annuler de l&apos;OP
                  </MenuItem>
                  <MenuItem
                    disabled={!isProductDeletable}
                    className={classes.popperBtn}
                    onClick={deleteEdb}
                  >
                    Supprimer de l&apos;EDB
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

export default PopperButtons;

const useStyles = createUseStyles(() => ({
  popperBtn: {
    fontWeight: "bold !important",
  },
}));
